import type { Feature } from '@luna/gatekeeper';

export const cardTracking: Feature = {
    enabled: false,
    _description:
        'Enables display of the card tracking feature card in the bank card settings, supplementary card settings and card functions page',
};
